import country from "fragments/vendors/country"
import { gql } from "graphql-tag"

const ADD_COUNTRY = gql`
  ${country}

  mutation addCountry($countryAddInput: CountryAddInput!) {
    addCountry(countryAddInput: $countryAddInput) {
      ...Country
    }
  }
`

export default ADD_COUNTRY
